import { computed, toRefs } from 'vue'
import usePlayer from '@/composables/usePlayer'
import { resolveWindowSafeRotation } from '@/helpers/bootViewportRotation'
import {
  cssEffectiveScreenOrientationFromState,
  cssEffectiveScreenRotationFromState
} from '@/helpers/cssEffectiveScreenRotation'
import { playerViewportRotationClassObject } from '@/helpers/playerViewportRotationClasses'

function liveWindowSize(fallback: { width: number, height: number }): { width: number, height: number } {
  if (typeof window !== 'undefined' && window.innerWidth > 0 && window.innerHeight > 0) {
    return { width: window.innerWidth, height: window.innerHeight }
  }
  return fallback
}

/** Reactive `:class` object for full-viewport layers that follow {@link playerViewportRotationClassObject}. */
export function usePlayerViewportRotationClasses() {
  const { state } = usePlayer()
  const { screenRotation, screenOrientation } = toRefs(state)
  const viewportRotationClasses = computed(() => {
    // Read reactive screenSize so the classes re-evaluate when the native rotation lands.
    void state.screenSize.width
    void state.screenSize.height
    const { width, height } = liveWindowSize(state.screenSize)
    const safe = resolveWindowSafeRotation(
      cssEffectiveScreenRotationFromState(state),
      cssEffectiveScreenOrientationFromState(state),
      width,
      height
    )
    return playerViewportRotationClassObject(safe.rotation, safe.orientation)
  })
  return { viewportRotationClasses, screenRotation, screenOrientation }
}
